import lodash from "lodash";
import { camelize } from "humps";
import { requestStatus, actionStrings, SEPARATOR, CALL_API } from "./constants";

export const getActionTypeByName = (typeName, status) => {
	switch (status) {
		case requestStatus.BEGIN:
			return (
				actionStrings.API_ACTION_PREFIX + typeName + actionStrings.API_BEGIN_SUFFIX
			);
		case requestStatus.SUCCESS:
			return (
				actionStrings.API_ACTION_PREFIX +
				typeName +
				actionStrings.API_SUCCESS_SUFFIX
			);
		case requestStatus.FAILURE:
			return (
				actionStrings.API_ACTION_PREFIX +
				typeName +
				actionStrings.API_FAILURE_SUFFIX
			);
	}
};

export const getTypeNameFromActionType = (actionType) => {
	const firstIndex = lodash.indexOf(actionType, SEPARATOR);
	const lastIndex = lodash.lastIndexOf(actionType, SEPARATOR);
	return actionType.substring(firstIndex + 1, lastIndex);
};

export const createApiActions = (
	action,
	{ request = {}, success = {}, failure = {} }
) => {
	return {
		request: lodash.assign(action, {
			type: getActionTypeByName(action.type, requestStatus.BEGIN),
			...begin
		}),
		success: lodash.assign(action, {
			type: getActionTypeByName(action.type, requestStatus.SUCCESS),
			...success
		}),
		failure: lodash.assign(action, {
			type: getActionTypeByName(action.type, requestStatus.FAILURE),
			...failure
		})
	};
};

export const isApiAction = (action) => {
	return lodash.startsWith(action.type, actionStrings.API_ACTION_PREFIX);
};

export const getDynamicResource = (
	resources,
	resourceType,
	typeResourceKey,
	messageResourceKey = null
) => {
	let dynamicResourceValue = null;
	const suffix = resourceType;
	const defaultKey = camelize(`${typeResourceKey}_${suffix}`);
	let messageSpecificKey = messageResourceKey
		? `${typeResourceKey}_${messageResourceKey}_${suffix}`
		: null;
	messageSpecificKey = camelize(messageSpecificKey);
	if (resources[messageSpecificKey]) {
		dynamicResourceValue = resources[messageSpecificKey];
	} else {
		dynamicResourceValue = resources[defaultKey];
	}
	return dynamicResourceValue;
};
